import FileUploader from '../../file-import/FileUploader'

function ProductSourceAddUpload(): JSX.Element {
  return (
    <FileUploader
      uploadType="apt"
      filenamePlaceholder="Upload your product list"
      hintText="Only use the template to upload your product URLs in bulk."
    />
  )
}

export default ProductSourceAddUpload
